// src/pages/Dashboard.js
import React from "react";
import { Layout } from "../components/Layout";
import Breadcrumb from "../components/Breadcrumb";

const Dashboard = () => {
  return (
    <Layout pageTitle="Dashboard">
      <Breadcrumb items={["Home", "Dashboard"]} />
      <p>Bem-vindo ao painel de controle.</p>
    </Layout>
  );
};

export default Dashboard;
